import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const MainButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: '10px',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  padding: '6px 8px',
  fontSize: '16px',
  width: '100%',
  height: '60px',
  boxShadow: 'none',
  fontWeight: 600,
  border: 0,
  '&:hover': {
    border: 0,
    backgroundColor: theme.palette.primary.dark,
  },
}));
export default MainButton;
